import { render, staticRenderFns } from "./DigitalContact.vue?vue&type=template&id=1c700bb8&scoped=true&"
import script from "./DigitalContact.vue?vue&type=script&lang=js&"
export * from "./DigitalContact.vue?vue&type=script&lang=js&"
import style0 from "./DigitalContact.vue?vue&type=style&index=0&id=1c700bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c700bb8",
  null
  
)

export default component.exports